module.exports = __webpack_public_path__ + "img/export-download.34449330.svg";